import { cn } from '@workspace/utils';

interface InfoLineProps {
  label: string;
  value: string | undefined;
  className?: string;
}

export const InfoLine = ({ label, value, className }: InfoLineProps) => (
  <div className={cn('flex justify-between gap-4 text-xs', className)}>
    <span className="text-gray-600">{label}</span>
    <span className="font-medium text-contrast text-right">{value || '-'}</span>
  </div>
);
